import { z } from 'zod';

import {
  DimensionBaseItemSchema,
  DimensionFormatTypeSchema,
  DimensionItemSchema,
  MetricScaleSchema,
} from './common.js';

export const PivotDimensionsResponseSchema = z.array(DimensionItemSchema);

const PivotDimensionUniquesDimensionSchema = DimensionBaseItemSchema.extend({
  dimensionType: DimensionFormatTypeSchema.optional(),
});

const PivotDimensionUniquesDimensionFilterSchema = z.object({
  id: z.string(),
  value: z.string(),
  dimensionType: DimensionFormatTypeSchema,
  isEqual: z.boolean().optional(),
  isContains: z.boolean().optional(),
  valueType: DimensionFormatTypeSchema.optional(),
});

const PivotDimensionUniquesMetricFilterSchema = z.object({
  id: z.string(),
  filter: z.array(z.string()),
});

const PivotDimensionUniquesTimeFilterSchema = z.object({
  since: z.string(),
  to: z.string(),
});

export const PivotDimensionUniquesRequestSchema = z.object({
  companyId: z.string(),
  metrics: z.array(z.string()).optional(),
  dimensions: z.array(PivotDimensionUniquesDimensionSchema),
  granularity: MetricScaleSchema.optional(),
  dimensionFilters: z
    .array(PivotDimensionUniquesDimensionFilterSchema)
    .optional(),
  metricFilters: z.array(PivotDimensionUniquesMetricFilterSchema).optional(),
  timeFilter: PivotDimensionUniquesTimeFilterSchema,
});

export const PivotDimensionUniquesResponseSchema = z.array(DimensionItemSchema);

export const PivotReachSubRowsRequestSchema = z.object({
  companyId: z.string(),
  platformId: z.string(),
  granularity: z.enum(['all']),
  timeFilter: z.object({
    since: z.string(),
    to: z.string(),
  }),
  tileId: z.string(),
  entities: z.array(
    z.object({
      entityId: z.string(),
      entityType: z.string(),
    }),
  ),
});

export const PivotReachSubRowSchema = z.object({
  entityId: z.string(),
  entityType: z.string(),
  value: z.number(),
  timestamp: z.string().optional(),
});

export const PivotReachSubRowsResponseSchema = z.object({
  companyId: z.string(),
  platformId: z.string(),
  granularity: z.string(),
  reaches: z.array(PivotReachSubRowSchema),
});

export const PivotFrequencySubRowsResponseSchema = z.object({
  companyId: z.string(),
  platformId: z.string(),
  granularity: z.string(),
  frequency: z.array(PivotReachSubRowSchema),
});
